import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetContentQuery } from "../service/content";
import { CONTENT_TYPE, TEASER_VIDEO_STATUS } from "../constants/enums";
import { useAppSelector } from "../hooks/store";
import { getRole } from "../reducers/authSlice";

const TeaserVideos = ({ shortVideo }: any) => {
  const navigate = useNavigate();
  const roleName = useAppSelector(getRole);
  const { data } = useGetContentQuery({
    setting: 1,
    contentType: shortVideo
      ? CONTENT_TYPE.SHORT_VIDEO
      : CONTENT_TYPE.TEASER_VIDEO,
    page: 1,
    limit: 100,
  });

  return (
    <>
      <div className="tsr_wp">
        <div className="gap_m">
          {data?.data?.data?.length
            ? data?.data?.data?.map((item: any, index: number) => {
                return (
                  <div
                    className="video-card"
                    onClick={() => {
                      if (item?.contentStatus !== TEASER_VIDEO_STATUS.PENDING) {
                        if (shortVideo) {
                          navigate(`/tutor/shortVideos/${item?._id}`);
                        } else {
                          navigate(
                            `/${roleName === "tutor" ? "tutor" : "parent"}/teaserVideos/${item?._id}`
                          );
                        }
                      }
                    }}
                  >
                    <video
                      src={item?.images?.[0] || "/static/videos/sample.mp4"} // replace with actual video url
                      muted
                      preload="metadata"
                      playsInline
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />

                    {item?.contentStatus == TEASER_VIDEO_STATUS.PENDING || item?.contentStatus == TEASER_VIDEO_STATUS.REJECTED ? (
                      <div className="waiting-approval">
                        <span>
                          <p>{ item?.contentStatus == TEASER_VIDEO_STATUS.REJECTED ? "Video Rejected": "Waiting for Approval"}</p>
                        </span>
                      </div>
                    ) : (
                      <div className="play-button">
                        <span>
                          <img src={`/static/images/play_icn.svg`} alt="Play" />
                        </span>
                      </div>
                    )}

                    <div className="video-details">
                      <h4>{item?.title || ""}</h4>

                      <div className="video-views">
                        <span>
                          <img
                            src={`/static/images/play_icn.svg`}
                            alt="Views"
                          />
                        </span>
                        <span>{item?.views || 0}</span>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </>
  );
};

export default TeaserVideos;
